import { lockPageScroll } from "@utils/lockPageScroll";
import {
  ModalState,
  MODAL_TYPES,
  ModalData,
  ModalGeneralProps,
} from "types/modals";
import { create } from "zustand";

type ModalsStore = {
  modals: ModalState;
};

const initialState: ModalsStore = { modals: [] };

export const useModals = create<ModalsStore>(() => initialState);

const getDialog = (type: MODAL_TYPES) =>
  document.getElementById(`dialog-${type}`) as HTMLDialogElement | null;

export const modalActions = {
  addModal<T extends MODAL_TYPES, D extends ModalData<T>>(
    type: T,
    payload: { config: ModalGeneralProps; data?: D }
  ) {
    const entry = {
      type,
      data: { config: payload.config, data: payload.data },
    };

    useModals.setState((state) => {
      const existingIndex = state.modals.findIndex((m) => m.type === type);

      if (existingIndex !== -1) {
        const next = [...state.modals];
        next[existingIndex] = entry;
        return { modals: next };
      }

      return { modals: [...state.modals, entry] };
    });

    if (!payload.config?.scrollFree) {
      lockPageScroll(true);
    }

    setTimeout(() => {
      const dialog = getDialog(type);
      if (dialog && !dialog.open) {
        dialog.showModal();
      }
    }, 0);
  },

  removeLastModal() {
    const { modals } = useModals.getState();
    if (modals.length === 0) return;

    const next = modals.slice(0, -1);
    useModals.setState({ modals: next });

    const shouldLock = next.some((m) => !m.data.config?.scrollFree);
    lockPageScroll(shouldLock);
  },

  clearModals() {
    useModals.setState(() => initialState);
    lockPageScroll(false);
  },
};
